import { createApp, type Component } from 'vue';
import { createPinia } from 'pinia';
import { registerSW } from 'virtual:pwa-register';

import App from './App.vue';

import './assets/scss/main.scss';

registerSW({
  immediate: true,
  onNeedRefresh(): void {
    // Можно показать баннер «Доступна новая версия» и предложить перезагрузку.
  },
  onOfflineReady(): void {
    // eslint-disable-next-line no-console
    console.log('[PWA] Приложение готово к офлайн-работе');
  },
  onRegisterError(error: unknown): void {
    // Безопасно логируем только в консоль; приложение продолжает работать как SPA.
    // eslint-disable-next-line no-console
    console.error('[PWA] Ошибка регистрации service worker', error);
  },
});

const app = createApp(App as Component);
app.use(createPinia());
app.mount('#app');
